export enum CacheDurationInSeconds {
    DEFAULT = 60,
}

export const CMS_STATIC_BLOCK_KEY_TEMPLATE = '#cms_key#';
export interface ApiRoute {
    path: string;
    cacheDuration?: CacheDurationInSeconds;
}
/**
 * Cache durations will only affect GET requests.
 * If you leave out `cacheDuration` it won't cache anything for the given path.
 */
const apiRoutes: { [apiRoute: string]: ApiRoute } = {
    CATEGORY_TREE: { path: '/categories/basic', cacheDuration: CacheDurationInSeconds.DEFAULT },
    BRANDS: { path: '/brands' },
    FEATURE_TOGGLES: { path: '/configuration/featuretoggles' },
    REMOTE_CONFIG: { path: '/configuration/bella' },
    LANDING_AND_STYLE_REDIRECTS: { path: '/configuration/redirects/landings' },
    HEADER_BAR_BANNER_DATA: { path: '/configuration/headerbarbanner' },
    CLUB_REGISTRATION_RESEND_DOI_EMAIL: { path: '/user/resenddoiconfirmation' },
    NEW_PRODUCTS: { path: '/products/newproducts', cacheDuration: CacheDurationInSeconds.DEFAULT },
    SEARCH_REDIRECTS: { path: '/search/redirects' },
    DYNAMIC_SEARCH_SUGGESTIONS: { path: '/web/v1/suggestions' },
    SEO: { path: '/seo', cacheDuration: CacheDurationInSeconds.DEFAULT },
    PRODUCTS_CATEGORY_URL_KEY: { path: '/products/category-url-key', cacheDuration: CacheDurationInSeconds.DEFAULT },
    PRODUCTS_BRAND_NAME: { path: '/products/brandname', cacheDuration: CacheDurationInSeconds.DEFAULT },
    PRODUCTS_LANDING_URL_KEY: { path: '/products/landing', cacheDuration: CacheDurationInSeconds.DEFAULT },
    PRODUCTS_TEXT_SEARCH: { path: '/products/textsearch', cacheDuration: CacheDurationInSeconds.DEFAULT },
    PRODUCT_DETAIL_PAGE: { path: '/web/v1/products/url_key' },
    PRODUCT_REVIEWS: { path: '/web/v1/products' },
    PRODUCT_LOOKS: { path: '/web/v1/content/entries/product/looks' },
    LOGIN_FACEBOOK: { path: '/user/login/facebook' },
    USER_LOGIN_WITH_HASH: { path: '/user/login/hash' },
    USER_CLUB_INTEGRATION_PIXEL: { path: '/user/clubssopixelurl' },
    GET_CART_COUNT: { path: '/cart/count' },
    GET_CART: { path: '/cart' },
    CART_ADD: { path: '/cart/add' },
    USER_REGISTER: { path: '/user/register' },
    USER_LOGIN: { path: '/user/login' },
    USER_LOGOUT: { path: '/user/logout' },
    USER_UNBLOCK: { path: '/web/v1/user/unblock' },
    USER_EMAIL_EXISTS: { path: '/user/emailexists' },
    USER_IS_FACEBOOK_ONLY: { path: '/user/isfacebookonly' },
    IS_AUTHENTICATED: { path: '/user' },
    WISHLIST: { path: '/wishlist' },
    WISHLIST_ADD: { path: '/wishlist/add' },
    WISHLIST_REMOVE: { path: '/wishlist/remove' },
    LOOKS_WISHLIST: { path: '/web/v1/wishlist/looks' },
    HEALTH_CHECK: { path: '/helper/healthcheck' },
    TRANSLATIONS_VERSION: { path: '/web/v1/utils/translations_version' },
    TRANSLATIONS: { path: '/web/v1/utils/translations' },
    CONTENT_INFUSION: { path: '/navigationinfusion' },
    CMS_STATIC_BLOCK: { path: `/cms/${CMS_STATIC_BLOCK_KEY_TEMPLATE}/staticblock/parsed` },
    CMS: { path: '/cms' },
    HELP_CENTER: { path: '/helpcenter/articles' },
    HOMEPAGE_CMS: { path: '/web/v2/homepage' },
    HOMEPAGE_NEW_PRODUCTS: { path: '/products/newproducts/assortment' },
    HOMEPAGE_BEST_SELLER_PRODUCTS: { path: '/web/v1/products/bestsellers' },
    HOMEPAGE_SEO: { path: '/seo/homepage' },
    LOOKS_SLIDER: { path: '/web/v1/content/entries/looks/slider' },
    LAST_BOUGHT_PRODUCT: { path: '/web/v1/users/products/lastboughtnotreviewed' },
    HEADER_BAR_BANNER_V2: { path: '/web/v1/content/entries/headerBar/active' },
    VALUE_PROPOSITIONS: { path: '/web/v1/content/entries/valuePropositions/active' },
    BACK_IN_STOCK_REMINDER: { path: '/web/v1/products/{simpleSku}/reminder' },
    FABRIC_SAMPLE: { path: '/web/v1/products/fabric' },
    LOOKSPAGE_LISTING: { path: '/web/v1/content/entries/looks' },
    LOOKSPAGE_DETAIL: { path: '/web/v1/content/entries/looks/slug' },
    NO_LOOKS_FOUND: { path: '/web/v1/content/entries/looksEmptyLook' },
    LOOK_PROMOTION_ELEMENTS: { path: '/web/v1/content/entries/looksPromotionalElements' },
    THREE_D_MODEL: { path: '/web/v1/content/entries/3dModels' },
    PROMOTION_INFUSIONS: { path: '/web/v1/content/entries/infusions' },
    IDS_DROPDOWN_DATA: { path: '/web/v1/content/entries/idsDropdownMenu' },
    IDS_FLYOUT_DATA: { path: '/web/v1/content/entries/idsInShopHoverFlyout' },
};
export default apiRoutes;
